/** Small helpers the Admin views share. */
import { toast } from 'sonner';

export function messageOf(err: unknown): string {
  return err instanceof Error ? err.message : String(err);
}

/** The error of a query or mutation as the components take it: a message, or null. */
export function errorText(err: unknown): string | null {
  return err === null || err === undefined ? null : messageOf(err);
}

/** Copy to the clipboard, and say whether it worked (a page without clipboard access says so). */
export function copyText(text: string, what: string): void {
  navigator.clipboard.writeText(text).then(
    () => toast.success(`${what} copied`),
    () => toast.error(`Could not copy the ${what.toLowerCase()}; select it and copy by hand`),
  );
}
